import React from 'react';
import { Menu } from '@headlessui/react';
import cx from 'classnames';

import { getIconFillColor } from './helpers';

import { defaultDisabled, defaultSize } from './constants';

/**
 * A dropdown option that only acts as a button, typically used to open a modal with contents such
 * as a DateRangePicker. Is intended for use within DropdownWrapper as part of a complex dropdown
 * menu, so it does not accept an `option` property and leaves selection management to its parent
 * component.
 * @param {DropdownOptionProps<V>} props
 */
export const DropdownOptionButton = ({
    addClasses,
    height,
    Icon,
    label,
    leftPadding = true,
    disabled = defaultDisabled,
    size = defaultSize,
    width,
    handleClick,
}: DropdownOptionButtonProps): JSX.Element => {
    const iconFillColor = getIconFillColor({
        disabled,
        size,
    });

    return (
        <Menu.Item disabled={disabled}>
            {({ active }): JSX.Element => (
                <button
                    type="button"
                    className={cx(
                        addClasses,
                        'dropdown-menu-item flex items-center text-left font-semibold w-full',
                        size,
                        {
                            'hover:underline': !disabled,
                            'bg-gray-100 text-gray-900': active,
                            'text-gray-700': !active,
                            'cursor-default': disabled,
                        },
                    )}
                    disabled={disabled}
                    onClick={handleClick}
                    style={{ height, width }}
                >
                    <div
                        className={cx({
                            'text-tertiary-300': disabled,
                            'pl-2': leftPadding,
                        })}
                    >
                        {Icon && (
                            <Icon
                                fillColor={iconFillColor}
                                width={18}
                                addClasses="ml-3 mr-2"
                            />
                        )}
                        {label}
                    </div>
                </button>
            )}
        </Menu.Item>
    );
};
